import React, {useEffect, useRef} from 'react'
import {useHistory} from 'react-router-dom'
import {useSelector} from 'react-redux'
import { Button } from '@material-ui/core';
import { useReactToPrint } from 'react-to-print';
import Lottie from 'react-lottie';
import animationData from '../lottie/success';
import axios from 'axios';
import {ApiURL} from '../constants/ApiUrl'

function FormSuccess() {
    const history = useHistory();
    // const dispatch = useDispatch();
    const printComp = useRef();
    const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    const FormStatus = useSelector(state => state.FormStatusReducer)
    const FormDataReducer = useSelector(state => state.FormDataReducer)

    // console.log(FormDataReducer,"reduce")

    const handlePrint = useReactToPrint({
        content: () => printComp.current,
       

        
      });
    // eslint-disable-next-line 
    useEffect(() => {
        
        console.log(FormDataReducer,"reduce")
        // console.log("runnnnn", FormStatus);
        if(!FormStatus)
            history.push('/');
        else
        {
            async function sendEmail(){

                const email = await axios.post(`${ApiURL}/cnf_send_mail`, {
                    "to_email": FormDataReducer.data.applicants[0].email
                })
                console.log(email.data)
            }
            sendEmail();
            // async function pushData(){                
            //     if(FormDataReducer.saved)
            //         return;
            //     // const result = await axios.post(`${ApiURL}/api/submit_application`, FormDataReducer.data);
            //     // if(result.data.status === 200){
            //     //     dispatch({type: "FORM_SAVED"});
            //     //     const email = await axios.post(`${ApiURL}/cnf_send_mail`, {
            //     //         "to_email": FormDataReducer.data.applicants[0].email
            //     //     })
            //     //     console.log(email);
            //     // }
            // }
            // pushData();
        }
        // eslint-disable-next-line 
    }, [FormStatus])
    return (
        <>
            <div style={{padding:'120px 0 100px 0 '}}>
                <div style={{textAlign:'center'}} ref={printComp}>
                    <h1>Congratulations!</h1>
                    <h2>Transaction Successful</h2>
                    <h3>Transaction ID - {FormDataReducer.transaction.id}</h3>
                    <h3>
                        <br/>
                        Amount - ₹ {FormDataReducer.transaction.amount/100} <br/>  </h3>
                        <Lottie options={defaultOptions} height={200} width={200}   />
                        {/* <img src={tick} style={{height: '200px', pointerEvents: 'none' }} alt="success" /><br/> */}
                    <h3>    Your application has been submitted successfully.<br/>
                        NMO team shall get in touch with you shortly.<br/>
                    </h3>
                    <Button variant="contained" onClick={handlePrint}>Print Receipt</Button>
                </div>
            </div>
        </>
    )
}

export default FormSuccess
